import { TransactionType, TransactionStatus } from 'skipify-types';

export enum MITStatus {
  PAID = 'PAID',
  FAILED = 'FAILED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  REFUNDED = 'REFUNDED',
}

export enum MITEventType {
  CREATED = 'CREATED',
  REFUNDED = 'REFUND_ISSUED',
}

export interface PaymentMethodDetails {
  networkType: string;
  lastFour: string;
  cardArtUrl?: string | null;
}

export interface PaymentMethod {
  details: PaymentMethodDetails;
}

export interface Customer {
  email: string;
  phone?: string | null;
  firstName: string;
  lastName: string;
  accountName?: string | null;
  paylinkCustomerId: string;
}

export interface MITEvent {
  eventId: string;
  mitId: string;
  eventType: MITEventType;
  createdBy: string;
  createdAt: string;
}

export interface Transaction {
  type: TransactionType;
  amount: number;
  timestamp: string;
  pspTransactionId: string;
  status: TransactionStatus;
}

export interface MIT {
  mitId: string;
  paylinkId: string;
  merchantId: string;
  transactionId: string;
  idempotencyKey: string;
  status: MITStatus;
  amount: number;
  currencyCode: string;
  paymentMethod: PaymentMethod;
  merchantReference: string;
  description: string;
  customer: Customer;
  createdBy: string;
  createdAt: string;
  mitEvents: MITEvent[];
}

export interface MITDetailedResponse extends MIT {
  transactions: Transaction[];
  refundedAmount: number;
  refundableAmount: number;
}

export interface CreateTransactionBody {
  paylinkId: string;
  amount: number;
  merchantReference: string;
  description?: string;
  customerChargeAgreement?: boolean;
}

export interface RefundMITBody {
  mitId: string;
  amount: number;
}

export interface RefundMITResponse {
  status: string;
  error?: string;
}

export interface GetAllMITsQueryFilters {
  status?: MITStatus[] | string;
  createdBefore?: string;
  createdAfter?: string;
  amountGTE?: number | string;
  amountLTE?: number | string;
  customerIds?: string[] | string;
}

export type GetAllMITsSortQuery = {
  sortBy?: 'createdAt' | 'amount' | 'status' | 'merchantReference';
  orderBy?: 'asc' | 'desc';
};

export type GetAllMITsQuery = GetAllMITsQueryFilters &
  GetAllMITsSortQuery & {
    merchantId: string;
    search?: string;
    pageSize?: number;
    pageNumber?: number;
  };
